<div class="auto-complete-wrapper" #autoCompleteWrapper>
    <acl-ngx-button *ngIf="buttonTrigger" [variant]="buttonProps.variant" [compact]="buttonProps.compact"
        [disabled]="_disabled" [dark]="buttonProps.dark" [icon]="buttonProps.icon" (click)="handleOnButtonClick()">
    </acl-ngx-button>
    <div *ngIf="showMenu || !buttonTrigger" class="auto-complete-dropdown-control" [ngStyle]="{'width': width}">
        <acl-ngx-input [compact]="searchProps.compact" [variant]="searchProps.variant" [dark]="searchProps.dark"
            [leftElement]="searchProps.leftElement" [placeholder]="searchProps.placeholder" [fluid]="searchProps.fluid"
            [formControl]="searchString" (click)="!_disabled && openMenu()">
        </acl-ngx-input>
        <div *ngIf="showMenu" (clickOutside)="closeMenu($event)" [ngStyle]="{'max-height': height}"
            class="auto-complete-dropdown" (infiniteScroll)="handleOnScroll($event)">
            <ng-container *ngFor="let item of items">
                <app-menu-item [label]="item.label" [value]="item.value" [disabled]="item.disabled"
                    (itemClick)="handleOnItemClick(item)">
                </app-menu-item>
            </ng-container>
        </div>
    </div>
</div>